import request from ".";

/**获取产品列表 */
function productList(data){
  return request('/product/default/amazon/productMain/productList', 'post', data)
}

/**临时保存 */
function saveTemp(data){
  return request('/product/default/amazon/productMain/saveTemp', 'post', data)
}

/**获取临时数据 */
function getTemp(data){
  return request('/product/default/amazon/productMain/getTemp', 'post', data)
}

/**清空临时数据 */
function clearTemp(data){
  return request('/product/default/amazon/productMain/clearTemp', 'post', data)
}

/**新建产品 */
function newProduct(data){
  return request('/product/default/amazon/productMain/newProduct', 'post', data)
}

/**更新产品 */
function updateProduct(data){
  return request('/product/default/amazon/productMain/updateProduct', 'post', data)
}

/**删除产品 */
function deleteProduct(id){
  return request('/product/default/amazon/productMain/' + id, 'delete')
}

/**获取产品详情 */
function getProductDetail(id){
  return request('/product/default/amazon/productMain/productInfo/' + id, 'post')
}

/**获取Listing列表 */
function getListingList(data){
  return request('/product/pro/listing/v2/listingList', 'post', data)
}

/**发补货所有listing */
function getWarehousingOption(data){
  return request('/product/pro/listing/v2/warehousingOption', 'post', data)
}

/**新建Listing */
function newListing(data){
  return request('/product/pro/listing/v2/newListing', 'post', data)
}

/**删除Listing */
function deleteListing(id){
  return request('/product/pro/listing/v2/deleteListing?listingId=' + id, 'post')
}

/**修改Listing */
function changeListing(data){
  return request('/product/pro/listing/v2/updateListing', 'post', data)
}

export default{
  productList, saveTemp, getTemp, updateProduct,
  newProduct, clearTemp, deleteProduct, getProductDetail,
  getListingList, newListing, deleteListing, changeListing,
  getWarehousingOption
}
